<div [id]="idLocal" style="width: 100%; border: 0" class="mapContainer fullMap" [style.height]="localHight"></div>